<template>
    <section>
      <div id="identifier"></div>

      <router-view/>

    </section>
</template>

<script>
  import './assets/js/defaultScripts';
  import './assets/css/custom.css';
  import { UTIL_SERVICE } from "./utils";

  export default {
    name: 'App',
    methods: {
      checkAccessV2() {
        if (location.href.includes('tid')) {
          UTIL_SERVICE.checkTokenV2ToAccessPage();
        }
      }
    },
    beforeMount() {
      this.checkAccessV2();
    },
    
    watch: {
    '$i18n.locale'() {
      // Force re-render when the locale changes
      this.$forceUpdate();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue